import moment from 'moment/moment';
import _ from 'lodash';
import { timeFormatUi, uiDateFormatShort, yearMonthDayFormat } from '../constants/date';

// to show date in ui:
export const formatTransactionDate = date => moment(date).format(uiDateFormatShort);
export const formatCheckInDate = date => moment(date).format(timeFormatUi);

// for events. On server event date are in format 'YYYY-MM-DD':
export const formatEventDate = dateObject => moment(dateObject).format(yearMonthDayFormat);

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
});

const formatterDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

/**
 *
 * @param {number} price
 * @returns {string}
 *
 * */

export const formatPrice = price => {
  let displayPrice = price;

  if (_.isUndefined(price)) {
    // This fixes incorrect view like 'Pay Rate $NaN /hr'
    displayPrice = 0;
  }

  return displayPrice % 1 === 0 ? formatter.format(displayPrice) : formatterDecimals.format(displayPrice);
};



// WEBPACK FOOTER //
// ./src/helpers/formatData.js